import { FoundationMeeting } from '@models';

export interface FoundationMeetingResult {
  foundationMeeting: FoundationMeeting;
}
